import { Controller } from "@hotwired/stimulus"
import { Timeline, reducedMotion } from "~/lib/motion"

// Base class for looping product demos. Subclasses implement:
//   reset()          put the demo back to its first frame
//   play(wait)       the script, using `await wait(ms)` between steps
// The loop runs only while the demo is on screen. With reduced motion it
// plays once, instantly, and stays on the final frame.
export default class AutoplayController extends Controller {
  connect() {
    this.timeline = new Timeline()
    this.cursor = this.element.querySelector(".mock-cursor")
    this.observer = new IntersectionObserver(([entry]) => {
      entry.isIntersecting ? this.start() : this.timeline.cancel()
    }, { threshold: 0.3 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
    this.timeline.cancel()
  }

  start() {
    this.timeline.run(async (wait) => {
      do {
        this.reset()
        this.parkCursor()
        await this.play(wait)
        await wait(3200)
      } while (!reducedMotion)
    })
  }

  reset() {}
  async play(_wait) {}

  // Fake pointer: rest in the bottom-right corner of the stage
  parkCursor() {
    if (!this.cursor) return
    const { offsetWidth: w, offsetHeight: h } = this.element
    this.cursor.style.transition = "none"
    this.cursor.style.transform = `translate(${w - 70}px, ${h - 50}px)`
    void this.cursor.offsetWidth
    this.cursor.style.transition = ""
  }

  // Glide to an element and press it. Uses offset maths (not getBoundingClientRect)
  // because the stage is scaled with a CSS transform.
  async click(target, wait) {
    let x = 0, y = 0
    for (let el = target; el && el !== this.element; el = el.offsetParent) {
      x += el.offsetLeft
      y += el.offsetTop
    }
    this.cursor.style.transform = `translate(${x + target.offsetWidth * 0.6}px, ${y + target.offsetHeight * 0.55}px)`
    await wait(750)
    this.cursor.classList.add("is-pressed")
    target.classList.add("is-pressed")
    await wait(160)
    this.cursor.classList.remove("is-pressed")
    target.classList.remove("is-pressed")
  }
}
